import { useEffect } from 'react';

import { useAppStore } from '@app/store/store';
import { applyRemoteAuthMessage } from '@features/authentication/store/authentication.broadcast';
import { type AuthBroadcastMessage, subscribeToAuthMessages } from '@features/authentication/utils/authBroadcast';

/**
 * Bridges the cross-tab BroadcastChannel into the Redux store. It subscribes once on mount and
 * applies every message received from another tab.
 *
 * Rendered as a sibling of the routed app (it renders nothing) so the subscription lives for the
 * whole app session, independent of which route is mounted.
 */
export const AuthBroadcastListener = () => {
  const store = useAppStore();

  useEffect(() => {
    const handleIncomingMessage = (message: AuthBroadcastMessage) => {
      const getFreshState = () => store.getState();

      void applyRemoteAuthMessage({
        message,
        dispatch: store.dispatch,
        getState: getFreshState,
      });
    };

    const unsubscribe = subscribeToAuthMessages(handleIncomingMessage);

    return () => {
      unsubscribe();
    };
  }, [store]);

  return null;
};
